import { ContentStatus } from '@monogrid/serverless-cms'
import { i18n as getI18n } from '@monogrid/vue-boost/i18n'
import type { ComputedRef } from 'vue'
import { computed, MaybeRefOrGetter, toValue } from 'vue'

export function useQueryVariables (variables?: Record<string, MaybeRefOrGetter<unknown>>): ComputedRef {
  const i18n = getI18n()
  const customVars = computed(() => {
    if (!variables) return
    return Object.entries(variables).reduce((acc, [key, value]) => {
      acc[key] = toValue(value)
      return acc
    }, {})
  })

  return computed(() => ({
    ...customVars.value,
    status: ContentStatus.PUBLISHED,
    variants: (i18n.locale.value as string === 'en') ? 'base' : i18n.locale.value
  }))
}
